import { Granularity } from 'types/contracts.ts'
import { ProductType } from 'types/types.ts'
import { PropsWithChildren } from 'react'

export type GranularityNavigationProps = PropsWithChildren<{
  allowSwitchAddress?: boolean
  alwaysShowGranularitySelector?: boolean
  /** Leave out to render the navigation without the billing cycle view */
  billingCycles?: { [key: string]: NavigationItem }
  disabledFilters?: boolean
  granularities: GranularityOptions
  labelContext?: 'prices'
}>

export type NavigationItem = {
  id: string
  type: NavigationItemType
  periods?: {
    label: string
    defaultSelected: boolean
    value: string
  }[]
} & (
  | {
      translationKey: 'quarterHour' | 'day' | 'month' | 'year'
      text?: never
    }
  | {
      translationKey?: never
      text: string
    }
)

export type GranularityOptions = {
  [Granularity.MONTH]: NavigationItem
  [Granularity.DAY]?: NavigationItem
  [Granularity.HOUR]?: NavigationItem
  [Granularity.QUARTER_HOUR]?: NavigationItem
}

export type GranularityNavigationInputs = {
  view: Granularity | NavigationItemType.CYCLE
  period: string
  activeProduct: ProductType
}

/** Variant of the navigation form for views without the billing cycle view */
export type GranularityNavigationForm = Omit<GranularityNavigationInputs, 'view'> & {
  view: Granularity
}

// ENUMS

export enum NavigationItemType {
  CYCLE = 'BILLING_CYCLE',
  GRANULARITY = 'GRANULARITY'
}
